import * as React from 'react';

import styles from './LocationsList.scss';
import SectionTitle from '../../SectionTitle/SectionTitle';
import { LocationsListLocale } from './locationsList.locale';

interface LocationsListProps {
  locale: LocationsListLocale;
}

const LocationsList: React.SFC<LocationsListProps> = ({ locale }) => (
  <div className="row mt-3 mt-md-5 mt-lg-8">
    {locale.map(location => (
      <div key={location.city} className="col-12 col-sm-6 col-md-3 mt-5">
        <SectionTitle>{location.city}</SectionTitle>
        {location.offices.map(office => (
          <div key={office.title} className="mt-3 mt-md-4">
            <strong>{office.title}</strong>
            <p
              className={styles.officeDescription}
              dangerouslySetInnerHTML={{ __html: office.description }}
            />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default LocationsList;



// WEBPACK FOOTER //
// /www/client/src/components/LocationsPage/LocationsList/LocationsList.tsx